module.exports = __webpack_public_path__ + "static/img/erase.ee84c625.png";